import { PropsWithChildren } from 'react';

import TopNavBar from '@/components/TopNavBar/TopNavBar.tsx';

export default function DefaultLayout({ children }: PropsWithChildren) {
  return (
    <div className="text-foreground bg-background relative flex flex-col min-h-screen">
      <TopNavBar />
      <main className="grow flex flex-col">
        {children}
      </main>
    </div>
  );
}
